import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Modal, Spin } from "antd";
const SpinnerModal = ({ open = false, title = "Please Wait", message, }) => {
    return (_jsxs(Modal, { open: open, title: title, closable: false, footer: false, children: [message && _jsx("h3", { className: "text-center", children: message }), _jsx("div", { className: "text-center", style: { "margin": "20px" }, children: _jsx(Spin, {}) })] }));
};
export default SpinnerModal;
